import React from 'react';
import PropTypes from 'prop-types';
import PageNotFound from './PageNotFound';
import LoadingLogo_v2 from './LoadingLogo_v2';
import { Wrapper } from '../styles/loading';

const LoadingViews = {
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  REGULAR_LOADING: 'REGULAR_LOADING',
};

export class LoadingComponent extends React.PureComponent {
  static propTypes = {
    isFinishedLoading: PropTypes.bool.isRequired,
    isAppLoaded: PropTypes.bool.isRequired,
    viewToDisplay: PropTypes.string.isRequired,
    appLoaded: PropTypes.func.isRequired,
  };

  state = {
    isLoading: true,
    unmount: false,
  };

  componentDidMount() {
    this.failSafeDismissTimer = setTimeout(() => {
      this.dismiss();
    }, this.failSafeDismissTimeout);
  }

  componentDidUpdate() {
    const { isFinishedLoading, isAppLoaded } = this.props;
    if (isAppLoaded) {
      this.props.appLoaded();
    }
    if (isFinishedLoading) {
      this.dismiss();
    }
  }

  failSafeDismissTimer;
  failSafeDismissTimeout = 7000;

  dismiss = () => {
    this.setState({
      isLoading: false,
    });
    setTimeout(() => {
      this.setState({ unmount: true });
      this.props.setPageIsReady();
    }, 250);
  };

  render() {
    const { viewToDisplay, text } = this.props;
    const { unmount, isLoading } = this.state;

    let finalRender = null;
    if (!unmount) {
      if (viewToDisplay === LoadingViews.PAGE_NOT_FOUND) {
        finalRender = (
          <Wrapper visible={isLoading}>
            <PageNotFound />
          </Wrapper>
        );
      } else {
        // retain application loading classname below for automation testing
        finalRender = (
          <LoadingLogo_v2
            className="application-loading-progress-wrapper"
            visible={isLoading}
            text={text}
          ></LoadingLogo_v2>
        );
      }
    }

    return finalRender;
  }
}
